module.exports = __webpack_public_path__ + "media/favicon/android-chrome-512x512-32d2cb2bed116b77da7a5295d8a7f919.png";